import React from 'react'

import { Suspense } from '~/components/elements/Suspense'

import { TimeSeriesSettings } from './components/TimeSeriesSettings'
import { useMainQuery } from './hooks/useMainQuery'

export const TimeSeriesSettingsPage = () => {
  const { isLoading } = useMainQuery()

  return (
    <Suspense loading={isLoading}>
      <TimeSeriesSettings />
    </Suspense>
  )
}
